export const includesSetting = (settings, key) =>
  settings.includes(key) || settings.includes(`attributes.${key}`);
